import React from 'react';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react"
import { Table } from '@tanstack/react-table';
import { IDraft, IErrorReturn, IResumeCard, IResumessTableColumns } from '@/lib/interfaces';

interface IColumnsSelector {
  table: Table<IDraft | IErrorReturn> | Table<IResumeCard | IErrorReturn>,
  VDraftsTableColumns: IResumessTableColumns
}

function ColumnsSelector({ table, VDraftsTableColumns }: IColumnsSelector) {
  return (
    <DropdownMenu>
        <DropdownMenuTrigger asChild>
            <Button variant="outline" className="ml-auto">
            Columns <ChevronDown />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
            {table
            .getAllColumns()
            .filter((column) => column.getCanHide())
            .map((column) => {

                return (
                <DropdownMenuCheckboxItem
                    key={column.id}
                    className="capitalize"
                    checked={column.getIsVisible()}
                    onCheckedChange={(value) =>
                    column.toggleVisibility(!!value)
                    }
                >
                    {VDraftsTableColumns[column.id]}
                </DropdownMenuCheckboxItem>
                )
            })}
        </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ColumnsSelector